import React, { useEffect, useState } from 'react'
import SertificateCard from '../../components/cards/SertificateCard'
import PageTitle from '../../components/common/PageTitle'
import ThankYouLetterCard from '../../components/cards/ThankYouLetterCard'
import CloseIcon from '../../assets/icons/CloseIcon'
import SectionHeader from '../../components/common/SectionHeader'
import { useDispatch, useSelector } from 'react-redux'
import { getCertificates, getThankyouletter } from '../../services/actions/MainAction'
import ImageZoom from "../../components/common/ImageZoom"
function Awards() {
    const [modalVisible, setModalVisible] = useState("");
    const contentData = useSelector(state => state.Data.contentData);
    const certificates = useSelector(state => state.Data.certificates);
    const thankyouletter = useSelector(state => state.Data.thankyouletter);
    const dispatch = useDispatch();

    useEffect(()=>{
        dispatch(getCertificates("acreditation"));
        window.scrollTo(0,0)
    },[])
  return (
    <main className=' min-h-[115vh] mb-[50px]'>
        <div className='container2  '>
            <section  className='mt-[50px]'>
                <SectionHeader title={contentData?.accreditation} />
                <div  className='grid grid-cols-3 gap-[40px]  relative mt-[30px] max-[1200px]:grid-cols-2 gap-y-[20px] max-[800px]:grid-cols-2 max-[500px]:grid-cols-1 gap-y-[0px]'>
                    {
                        certificates?.map((data, i)=>{
                            return(
                                <SertificateCard url={data?.image_full_url} onOpen={()=>setModalVisible(data?.image_full_url)} />
                            )
                        })
                    }
                    
                </div>
            </section>
        </div>
        {
            modalVisible !==""?
            <div className="bg-black/70 fixed top-0 left-0 w-full h-screen flex items-center justify-center z-[1000] ">
                <button  onClick={()=>setModalVisible("")} className="absolute right-[30px] top-[30px]">
                    <CloseIcon />
                </button>
                {/* 
                <div className="max-w-[700px] h-auto max-h-[60vh] bg-[red] ">
                    <img className="max-w-full max-h-[60vh]" src={modalVisible} />
                </div> */}
                <ImageZoom url={modalVisible} />
            </div>:null
        }
       
    </main>
  )
}

export default Awards
